'use client'
import { useEffect } from "react"
import styles from "./error.module.css";
import ContentWrapper from "src/components/contentwrapper/ContentWrapper";
import FilmwebLink from "src/components/filmweblink/FilmwebLink";
import ChunkErrorRecovery from "src/components/error/ChunkErrorRecovery";

// Error boundaries must be Client Components

export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {

    useEffect(() => {
        // Log the error to an error reporting service
        console.error(error);
        window?.dataLayer?.push({
            event: "ERROR",
            eventCategory: error?.name ?? `ERROR_${error.digest}`,
            eventAction: error?.cause,
            eventLabel: error?.message,
        });
    }, [error])
    return (

        // global-error must include html and body tags
        <html>
            <body data-build={process.env.NEXT_PUBLIC_BUILD_ID}>
                {process.env.NEXT_PUBLIC_WEBSITE_BRAND === "filmweb" &&
                    <ContentWrapper className={styles.SContentWrapper}>
                        <h1 className={styles.SSectionTitle}>Jaiks!</h1>
                        <h2 className={styles.SSectionSubTitle}>Neeeei, huff!</h2>
                        <p>Flaut! En feil har oppstått. Kan ikke vise siden. Prøv å laste siden på nytt. Må skifte olje i maskineriet. Våre teknikere er på saken.</p>

                        <h3 className={styles.SSectionParagraphTitle}>Vi anbefaler deg å prøve en av følgende:</h3>
                        <ul>
                            <li>Filmwebs <FilmwebLink to="/" hardLink>forside</FilmwebLink></li>
                            <li><FilmwebLink to="/program" hardLink>Kinoprogrammet</FilmwebLink></li>
                            <li><FilmwebLink to="/streamingguide" hardLink>Streamingguiden</FilmwebLink></li>
                            <li>Bruk søkefeltet i menyen</li>
                        </ul>
                    </ContentWrapper>}
                {process.env.NEXT_PUBLIC_WEBSITE_BRAND === "kinodk" &&
                    <ContentWrapper className={styles.SContentWrapper}>
                        <h1 className={styles.SSectionTitle}>Øv!</h1>
                        <h2 className={styles.SSectionSubTitle}>Neeeej, altså!</h2>
                        <p>
                            Pinligt! Der er opstået en fejl. Siden kan ikke vises. Prøv at genindlæse siden.
                            Vi skal lige have skiftet olie i maskineriet. Vores teknikere er på sagen.
                        </p>

                        <h3 className={styles.SSectionParagraphTitle}>Vi anbefaler, at du prøver en af følgende:</h3>
                        <ul>
                            <li>Kino.dks <FilmwebLink to="/" hardLink>forside</FilmwebLink></li>
                            <li><FilmwebLink to="/program" hardLink>Biografprogrammet</FilmwebLink></li>
                            {/*<li><FilmwebLink to="/streamingguide">Streamingguiden</FilmwebLink></li>*/}
                            <li>Brug søgefeltet i menuen</li>
                        </ul>
                    </ContentWrapper>}
                <ChunkErrorRecovery error={error} />
            </body>
        </html>
    )
}